import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { useState } from 'react';
import { CustomerRecord } from '../../models/customer.models';
import { ProcessStatus } from '../../enum/process-status.enum';
import { useMutateCustomerStatus } from '../../api/admin';
import './CustomerCenterPage.scss';

interface UpdateCustomerStatusModalProps {
  customer: CustomerRecord;
  open: boolean;
  setOpen: (value: boolean) => void;
  setIsSuccess: (value: boolean) => void;
  setShowSnackbar: (value: boolean) => void;
}

export const UpdateCustomerStatusModal = (
  props: UpdateCustomerStatusModalProps
) => {
  const { customer, open, setOpen, setIsSuccess, setShowSnackbar } = props;
  const mutation = useMutateCustomerStatus();
  const [status, setStatus] = useState<ProcessStatus>(customer.processStatus);

  const handleClick = () => {
    mutation.mutate(
      {
        customerSub: customer.pk,
        processStatus: status,
      },
      {
        onSuccess: () => {
          setIsSuccess(true);
          setShowSnackbar(true);
          setOpen(false);
        },
        onError: () => {
          setIsSuccess(false);
          setShowSnackbar(true);
          setShowSnackbar(true);
        },
      }
    );
  };

  const handleChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value as ProcessStatus);
  };

  const formatProcessStatus = (status: ProcessStatus): string => {
    const statusMap: { [key in ProcessStatus]: string } = {
      [ProcessStatus.UNPAID]: 'Unpaid',
      [ProcessStatus.PAID_LAND]: 'Paid Land',
      [ProcessStatus.PAID_HOME]: 'Paid Home',
      [ProcessStatus.PAID_LAND_AND_HOME]: 'Paid Land and Home',
      [ProcessStatus.OVERRIDE]: 'Override',
    };

    return statusMap[status];
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      id="update-cutomer-status-modal"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Update customer status</DialogTitle>
      <DialogActions
        sx={{ display: 'flex', flexDirection: 'column', padding: '24px' }}
      >
        <FormControl fullWidth variant="outlined" margin="normal">
          <InputLabel id="process-status-select-label">
            Process Status
          </InputLabel>
          <Select
            labelId="process-status-select-label"
            value={status}
            onChange={(event) => handleChange(event)}
            label="Process Status"
          >
            {Object.values(ProcessStatus).map((status) => (
              <MenuItem key={status} value={status}>
                {formatProcessStatus(status)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          className="update-customer-button"
          disabled={mutation.isPending}
          onClick={handleClick}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
